import { Router } from '@angular/router';

/**
 * Format UUID 8-4-4-4-12 (hex), aligné sur UUID.fromString côté Java.
 * Ne pas restreindre le 1er quartet du 3ᵉ groupe aux seuls chiffres 1–8 : ce n’est pas la version RFC
 * (ex. e743 est hex valide) et une regex trop stricte empêchait la garde d’appliquer adminPreviewUserId.
 */
const ADMIN_PREVIEW_USER_ID_HEX =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;

export function parseAdminPreviewUserIdFromRaw(value: string | null | undefined): string | null {
  const id = value?.trim();
  if (!id || !ADMIN_PREVIEW_USER_ID_HEX.test(id)) {
    return null;
  }
  return id;
}

export function parseAdminPreviewUserIdFromRouterUrl(router: Router, rawUrl: string): string | null {
  return parseAdminPreviewUserIdFromRaw(router.parseUrl(rawUrl).queryParamMap.get('adminPreviewUserId'));
}
